import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';

class MockResponseRefEntity extends Entity {
  static fields: EntityFields<MockResponseRefEntityFields> = {
    uuid: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
    status_code: new Fields.IntegerField({ blank: true, local: true }),
  };
}

export type MockResponseRefEntityFields = {
  uuid: string;
  name: string;
  status_code: number | null;
};

export type MockResponseRefEntityRecord =
  EntityRecord<MockResponseRefEntityFields>;

export default MockResponseRefEntity;
